import script from "./MesageContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./MesageContainer.vue?vue&type=script&setup=true&lang=ts"

import "./MesageContainer.vue?vue&type=style&index=0&id=6b1649a3&lang=scss"
import "./MesageContainer.vue?vue&type=style&index=1&id=6b1649a3&lang=scss&scoped=true"
import "./MesageContainer.vue?vue&type=style&index=2&id=6b1649a3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b1649a3"]])

export default __exports__